import { debugLog } from "../debug/debug";

export class AppStorage {
    appID: string;
    constructor(appID: string) {
        this.appID = appID;
    }
    clear() {
        return localStorage.clear();
    }
    getItem(key: string) {
        debugLog("storage get", key);
        return localStorage.getItem(`${this.appID}@${key}`);
    }
    setItem(key: string, value: string) {
        debugLog("storage set", key);
        return localStorage.setItem(`${this.appID}@${key}`, value);
    }
}

export * from "./use-storage";
